var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-reference-back-btn show-for-large"},[_c('span',{staticClass:"arrow-left"},[_vm._v("\n            <\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0995c7f8","hasScoped":true,"buble":{"transforms":{}}}!./src/components/*Work/reference-back-btn/ReferenceBackBtn.html
// module id = null
// module chunks = 